module.exports = __webpack_public_path__ + "static/media/sadface.802eba96.svg";